type EnvVar =
	| 'MODE'
	| 'APP_URL_CORE_API'
	| 'STRIPE_PUBLISHABLE_KEY'
	| 'URL_TERMS_OF_SERVICE'
	| 'URL_PRIVACY_POLICY'
	| 'PARENT_ORIGIN'
	| 'USERSNAP_AUTORENEWAL_PROJECT_KEY';

export function getClientEnv(envVar: EnvVar): string {
	const envVarReactMap: Record<EnvVar, string> = {
		MODE: 'MODE',
		APP_URL_CORE_API: 'VITE_APP_URL_CORE_API',
		STRIPE_PUBLISHABLE_KEY: 'VITE_STRIPE_PUBLISHABLE_KEY',
		URL_TERMS_OF_SERVICE: 'VITE_URL_TERMS_OF_SERVICE',
		URL_PRIVACY_POLICY: 'VITE_URL_PRIVACY_POLICY',
		PARENT_ORIGIN: 'VITE_PARENT_ORIGIN',
		USERSNAP_AUTORENEWAL_PROJECT_KEY: 'VITE_USERSNAP_AUTORENEWAL_PROJECT_KEY',
	};

	// @ts-ignore -- import.meta.env is provided by Vite at runtime
	return import.meta.env[envVarReactMap[envVar]] || '';
}
